'use client'

import { useCallback } from 'react'

import { signOut as nextAuthSignOut, useSession } from 'next-auth/react'

import { useQueryClient } from '@tanstack/react-query'
const BOOTSTRAP_QUERY_KEY = ['bootstrap'] as const

type SignOutOptions = Parameters<typeof nextAuthSignOut>[0]

export function useSignOutWithBootstrapPurge() {
  const queryClient = useQueryClient()
  const { data: session } = useSession()

  const signOut = useCallback(
    (options?: SignOutOptions) => {
      queryClient.removeQueries({ queryKey: BOOTSTRAP_QUERY_KEY })
      const userId = session?.user?.id
      if (typeof userId === 'string' && typeof window !== 'undefined') {
        const userKeyPrefix = `pgee-cache-${userId}-`
        const keys = Object.keys(window.localStorage)
        keys.forEach(key => {
          if (key.startsWith(userKeyPrefix)) {
            window.localStorage.removeItem(key)
          }
        })
      }
      nextAuthSignOut(options)
    },
    [queryClient, session?.user?.id]
  )

  return { signOut }
}
